import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  default as TextInput,
  InputUITypes,
  ValidationTypes
} from '@adsk/bim360-matrix-react-text-input';
import i18n from '../../utils/i18n';
import noop from 'lodash/noop';
import {useNewValueWithPristineFlag} from '../common/formHooks';
import {getIssueTemplateCategoryValidators} from '../../utils/issue-template-helpers';

const TemplateCategoryNewRow = ({
  isOpen,
  loading,
  createTemplateCategoryAction,
  onSuccess,
  onError,
  onCancel,
  templateCategoryTitles,
  container
}) => {
  const [title, onChange, isPristine, resetField] = useNewValueWithPristineFlag();
  return (
    <div
      className={classnames('TemplateCategoryNewRow', {
        'TemplateCategoryNewRow--open': isOpen
      })}
    >
      <TextInput
        value={title}
        editableProps={{
          inEdit: isOpen && !loading,
          isLoading: loading
        }}
        inputUIType={InputUITypes.INLINE_EDIT}
        validationProps={{
          type: ValidationTypes.POPOVER,
          validator: getIssueTemplateCategoryValidators(templateCategoryTitles),
          ignore: isPristine,
          required: true,
          typeProps: {
            container
          }
        }}
        inputProps={{
          className: 'TemplateCategoryNewRow-field',
          placeholder: i18n.t('createCategory.title.placeholder'),
          autoselect: true,
          onChange,
          onInlineEditEnd: (value, isCancel) => {
            if (!isCancel && value) {
              createTemplateCategoryAction(
                {title: value},
                {
                  onSuccess: () => {
                    onSuccess(value);
                  },
                  onError: () => {
                    onError();
                  }
                }
              );
            } else {
              onCancel();
            }
            resetField();
          }
        }}
      />
    </div>
  );
};

TemplateCategoryNewRow.displayName = 'TemplateCategoryNewRow';

TemplateCategoryNewRow.defaultProps = {
  onSuccess: noop,
  onError: noop,
  onCancel: noop
};

TemplateCategoryNewRow.propTypes = {
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  createTemplateCategoryAction: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  templateCategoryTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  container: PropTypes.object
};

export default TemplateCategoryNewRow;
